import React from "react";
import { login } from "services/UserService";
import defaultLogo from "../../assets/new-logo.png";
import { CDN_WIDGET_URL, removeDotFromStart } from "utils/WidgetUtil";
import { useSelector } from "react-redux";
import { selectAppLogo } from "../../store/app-config/AppConfigSelectors";
import ButtonComponent from "components/common/ButtonComponent";
import { Box, Paper, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useStyles } from "./LogoutStyles";

interface AuthPageBaseProps {
  titleMessageId: string;
  titleDefaultMessage: string;
  bodyMessageId: string;
  bodyDefaultMessage: string;
  paperPadding?: string;
  buttonContainerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  loginWithErrorPage?: boolean;
  additionalContent?: React.ReactNode;
}

const AuthPageBase: React.FC<AuthPageBaseProps> = ({
  titleMessageId,
  titleDefaultMessage,
  bodyMessageId,
  bodyDefaultMessage,
  paperPadding = "140px 30px",
  buttonContainerStyle = { marginTop: "40px" },
  buttonStyle = {},
  loginWithErrorPage = false,
  additionalContent,
}) => {
  const classes = useStyles();
  const appLogo = useSelector(selectAppLogo);
  const intl = useIntl();

  const handleLogin = async () => {
    try {
      await login(loginWithErrorPage);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className={classes.container}>
      <Paper
        className={classes.paper}
        elevation={0}
        style={{ padding: paperPadding }}
      >
        <img
          src={appLogo || `${CDN_WIDGET_URL}${removeDotFromStart(defaultLogo)}`}
          alt="Smart Merchandiser Logo"
          className={classes.logo}
        />
        <Typography variant="h5" className={classes.title}>
          {intl.formatMessage({
            id: titleMessageId,
            defaultMessage: titleDefaultMessage,
          })}
        </Typography>
        <Typography
          variant="body1"
          className={classes.message}
          style={{ marginBottom: additionalContent ? "12px" : undefined }}
        >
          {intl.formatMessage({
            id: bodyMessageId,
            defaultMessage: bodyDefaultMessage,
          })}
        </Typography>
        {additionalContent}
        <Box className={classes.buttonContainer} style={buttonContainerStyle}>
          <ButtonComponent
            onClick={handleLogin}
            variant="contained"
            color="primary"
            fullWidth={true}
            justifyContent="center"
            style={buttonStyle}
          >
            {intl.formatMessage({
              id: "logoutPage.loginAgainText",
              defaultMessage: "Log In Again",
            })}
          </ButtonComponent>
        </Box>
      </Paper>
    </div>
  );
};

export default AuthPageBase;
